import { render } from "./ItemListView.vue?vue&type=template&id=5abfe9bd&scoped=true&ts=true"
import script from "./ItemListView.vue?vue&type=script&lang=ts"
export * from "./ItemListView.vue?vue&type=script&lang=ts"

import "./ItemListView.vue?vue&type=style&index=0&id=5abfe9bd&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abfe9bd"]])

export default __exports__